import { getUserToken } from '.'

type Headers = {
    [key: string]: string
}

export const getHeadersContext = async (headers: Headers) => {
    const userToken = await getUserToken()
    const defaultHeader = {
        headers: {
            ...headers,
        },
    }

    if (userToken?.token) {
        if (defaultHeader.headers.authorization === 'expired') {
            delete defaultHeader.headers.authorization
            return { ...defaultHeader }
        }

        return {
            headers: {
                authorization: `Bearer ${userToken.token}`,
                ...headers,
            },
        }
    }

    return { ...defaultHeader }
}
